<template>
  <footer class="footer">
    <div>
        <span class="footer-text">版权所有：国家市场监督管理总局</span>
        <!--<span class="footer-text">承建单位：国家市场监督管理总局信息中心</span>-->
        <span class="footer-text" style="white-space: nowrap ;">技术支持：中认信安（北京）技术服务有限公司</span>
    </div>
  </footer> 
  <!--
  <footer class="footer">
    <div>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="4"><div class="grid-content bg-purple">版权所有：国家市场监督管理总局</div></el-col>
          <el-col :span="4"><div class="grid-content bg-purple-light">承建单位：国家市场监督管理总局信息中心</div></el-col>
          <el-col :span="4"><div class="grid-content bg-purple">技术支持：中认信安（北京）技术服务有限公司</div></el-col>
        </el-row>
    </div>
  </footer>
  --> 
</template>
<script>
export default {
  name: 'AppFoot'
}
</script>
<style scoped>
.outDiv11111{
  /* position:relative; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.footer11111 {
  /* top: calc(16% - 50px);
  position: relative;  */
  
    flex: 0 0 auto;
}

.footer {
  width: 100%;
  position:fixed;
  /* position:absolute; */
  padding: 15px 0;
  /* top: 0; */
    bottom: 0;
    /* left: 0;
    right: 0; */
    margin: auto;
    text-align: center;
  /* justify-content: center;
  align-items: center; */
  z-index: 999;
  height: 40px;
  background: #F1F2F2;
  overflow: hidden;
  font-size: 12px;
  color: #999999;
  /* min-width: 1200px; */
}

.footer-text {
  display: inline-block;
  min-width: 240px;
  white-space: nowrap;
  width: 21%;
  color: #999999;
}


</style>
